import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { I18nProvider } from '@uhg-abyss/web/ui/I18nProvider';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { find } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { phoneOnly } from '../../../../common/ConstantsStyles';
import { Markdown } from '../../../../common/Markdown';
import { useLagoon } from '../../../../hooks/useLagoon';
import { EmpirePolicyAlertStyling } from './FacilityDetails.styled';

export const FacilityBanner = () => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  const [isVisible, setIsVisible] = useState(true);
  const [isEmpirePolicyDrawerOpen, setIsEmpirePolicyDrawerOpen] =
    useState(false);
  const uiMessaging = useLagoon('ui-messaging')();
  const empirePlicyBannerContent = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.ANTHEM_BLUE_CROSS_DISCLAIMER,
  });
  const empirePolicyDisclaimerPopupContent = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.ANTHEM_BLUE_CROSS_DISCLAIMER_POPUP,
  });

  const StyledDrawer = styled(Drawer, {
    zIndex: '999 !important',
    '.abyss-modal-header-container': {
      width: 'fit-content',
    },
    '.abyss-modal-base-content-container': {
      borderRadius: 0,
      width: '408px',
      '@media (max-width: 464px)': {
        height: '70vh !important',
        width: '100%',
        borderRadius: '20px 20px 0px 0px',
        border: '1px solid $core.color.brand.100',
      },
    },
    '.abyss-modal-close-button': {
      '@media (max-width: 464px)': {
        top: '12px',
        right: '12px',
      },
    },
    '.abyss-modal-base-body': {
      padding: '8px 16px 8px 16px',
    },
  });
  const buttonStyles = {
    margin: '$sm $lg $sm $md',
    float: 'right',
  };

  const renderEmpirePolicyCoverageDetailsDrawer = () => (
    <>
      {isEmpirePolicyDrawerOpen ? (
        <StyledDrawer
          data-testid="coverage-details-drawer"
          header={empirePolicyDisclaimerPopupContent?.title}
          isOpen={isEmpirePolicyDrawerOpen}
          onClose={() => setIsEmpirePolicyDrawerOpen(false)}
          position="right"
          size={mobileScreen && 'fit-content'}
        >
          <Markdown data-testid="coverage-details-drawer-message">
            {empirePolicyDisclaimerPopupContent?.message}
          </Markdown>
          <Button
            css={{ 'abyss-button-root': { ...buttonStyles } }}
            data-auto-testid="close-empire-policy-drawer-button"
            data-testid="close-empire-policy-drawer-button"
            onClick={() => setIsEmpirePolicyDrawerOpen(false)}
            size="$md"
          >
            {t(
              'ANTHEM_BLUE_CROSS_DISCLAIMER.ANTHEM_BLUE_CROSS_DISCLAIMER_POPUP.CLOSE_BUTTON'
            )}
          </Button>
        </StyledDrawer>
      ) : null}
    </>
  );

  const renderAlertContent = () => (
    <>
      {renderEmpirePolicyCoverageDetailsDrawer()}
      <Markdown>{empirePlicyBannerContent?.message}</Markdown>
      <Link
        css={!mobileScreen && { marginLeft: '10px' }}
        data-auto-testid="view-coverage-details"
        data-testid="view-coverage-details"
        isStandardAnchor
        onClick={() => {
          setIsEmpirePolicyDrawerOpen(true);
        }}
        size="$md"
      >
        {t('ANTHEM_BLUE_CROSS_DISCLAIMER.LINK_TEXT')}
      </Link>
    </>
  );
  return (
    <>
      <I18nProvider translations={{ close: 'Close message' }}>
        <Alert
          css={!mobileScreen && EmpirePolicyAlertStyling}
          data-testid="anthem-blue-cross-banner"
          isVisible={isVisible}
          onClose={() => {
            setIsVisible(!isVisible);
          }}
          status="info"
          title={empirePlicyBannerContent?.title}
        >
          <Layout.Stack>
            {mobileScreen ? (
              renderAlertContent()
            ) : (
              <Layout.Group
                css={{
                  'abyss-layout-group': {
                    '& > div > div': {
                      lineHeight: '1px',
                      alignSelf: 'center',
                    },
                  },
                }}
              >
                {renderAlertContent()}
              </Layout.Group>
            )}
          </Layout.Stack>
        </Alert>
      </I18nProvider>
    </>
  );
};
